import { Box, useTheme } from '@mui/material';

import { IProductConsumerScanTransactionsData } from 'src/types';

import { useCustomModal } from 'src/hooks';
import { AIVerifiedModal } from './ai-verified-modal';
import { BlockchainVerifiedIcon } from 'src/assets/icons/v2/BlockchainVerifiedIcon';

interface IProps {
  data: IProductConsumerScanTransactionsData[];
  aiVerifiedCount: number;
}

export const AIVerifiedBannerAll = ({ data, aiVerifiedCount }: IProps) => {
  const { handleClose, handleOpen, open } = useCustomModal();
  const theme = useTheme();

  return (
    <>
      <Box id="ai-verified-banner-all__components-ai-verified-banner__box__l20" sx={{ width: '40px', cursor: 'pointer' }} onClick={handleOpen}>
        <BlockchainVerifiedIcon size={40} stroke={theme.palette.primary.main} />
      </Box>

      {data && data?.length > 0 &&
      <AIVerifiedModal
        handleClose={handleClose}
        open={open}
        data={data}
        aiVerifiedCount={aiVerifiedCount} />

      }
    </>);

};